import React from "react";
import { Row, Col, Input, Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";

const TemplateSearchBar = ({
  searchText,
  onSearchChange,
  onCreateTemplate,
}) => {
  return (
    <Row gutter={[8, 8]} style={{ marginBottom: 16 }}>
      <Col xs={24} sm={16} md={18}>
        <Input
          placeholder="Search templates..."
          allowClear
          size="large"
          value={searchText}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </Col>
      <Col xs={24} sm={8} md={6}>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          size="large"
          block
          onClick={onCreateTemplate}
        >
          Create Template
        </Button>
      </Col>
    </Row>
  );
};

export default TemplateSearchBar;
